'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoJet = function IoJet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.8 28.8l-0.1 1 4.1 4.5-1.4 2.1-5.8-0.7-1.4 4.3-1.4-4.3-5.8 0.7-1.4-2.1 4.2-4.5-0.2-1-8.1 2.7 0.2-4.2 8.9-8s2.1-13.5 2.2-15c0.4-3.1 1.4-4.3 1.4-4.3s1.1 1.2 1.4 4.3c0.2 1.5 2.2 15 2.2 15l8.9 8 0.3 4.2z' })
        )
    );
};

exports.default = IoJet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/jet.js
// module id = 2356
// module chunks = 0